module.exports = __webpack_public_path__ + "static/benefits-img3-17a0da646f9583f7acc2383fa688cbc8.png";